import { inject, Pipe, PipeTransform } from '@angular/core';

import { AntragHelperService } from '../../antrags-overview/antrag-helper.service';

@Pipe({
  name: 'statusToI18n',
})
export class StatusToI18nPipe implements PipeTransform {
  public antragsHelper: AntragHelperService = inject(AntragHelperService);

  public transform(value: string): string {
    return this.antragsHelper.getStateI18nKey(value);
  }
}
